import { render, staticRenderFns } from "./ManageChecklistItem.vue?vue&type=template&id=c56422b2&scoped=true"
import script from "./ManageChecklistItem.vue?vue&type=script&lang=js"
export * from "./ManageChecklistItem.vue?vue&type=script&lang=js"
import style0 from "./ManageChecklistItem.vue?vue&type=style&index=0&id=c56422b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56422b2",
  null
  
)

export default component.exports